var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "upload_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#upload_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#009EE7",
  d: "M4.001 13.333c-.366 0-.68-.131-.941-.392a1.284 1.284 0 0 1-.392-.942v-1.333c0-.189.064-.347.192-.475a.645.645 0 0 1 .475-.192c.189 0 .347.064.475.192a.645.645 0 0 1 .191.475v1.333h8v-1.333c0-.189.064-.347.192-.475a.645.645 0 0 1 .475-.192c.189 0 .347.064.475.192a.645.645 0 0 1 .192.475v1.333c0 .367-.13.68-.392.942a1.284 1.284 0 0 1-.942.392h-8Zm3.334-8.1-1.25 1.25a.62.62 0 0 1-.475.191A.68.68 0 0 1 4.943 6a.61.61 0 0 1 .192-.466l2.4-2.4a.585.585 0 0 1 .216-.142.738.738 0 0 1 .25-.042c.09 0 .173.014.25.042.078.028.15.075.217.142l2.4 2.4a.61.61 0 0 1 .192.466.68.68 0 0 1-.667.675.62.62 0 0 1-.475-.191l-1.25-1.25v4.766a.645.645 0 0 1-.192.475.645.645 0 0 1-.475.192.645.645 0 0 1-.475-.192.645.645 0 0 1-.191-.475V5.233Z"
}))));
export default SvgUpload;